<template>
  <div class="faq">
    <loading v-if="loading"></loading>
    <div class="m-container" v-else>
      <h1>Hello, How can we help you ?</h1>
      <!-- search faq -->
      <form class="search-faq position-relative" @submit.prevent="selectCat">
        <img src="@/assets/img/search-icon.png" alt="" class="search-icon">
        <input type="text" placeholder="Ask As Questions ..." v-model="form.question">
        <button type="submit">search</button>
      </form>

      <p class="choose-cat">or choose category to quickly find the help you need </p>

      <div class="row faq-blocks">
        <div class="col-6 col-md-6 col-lg-3 cat-item" @click="selectedCat = '0'; selectedCategory={name: 'All Questions'}">
          <div class="faq-block" :class="{'active': selectedCat == '0'}">
            <svg width="45.333" height="45.333" viewBox="0 0 45.333 45.333">
              <path id="Path_55029" data-name="Path 55029"
                    d="M45.28,3.384A3.524,3.524,0,0,0,41.949.053,34.994,34.994,0,0,0,24.406,3.565,34.44,34.44,0,0,0,14.349,11.9l-.107.13L7.6,12.547a3.5,3.5,0,0,0-2.671,1.571L.4,20.969a2.428,2.428,0,0,0,1.653,3.738l5.593.866c-.02.109-.04.217-.058.326a3.522,3.522,0,0,0,.987,3.063l7.791,7.791a3.531,3.531,0,0,0,2.492,1.035,3.472,3.472,0,0,0,.572-.047c.109-.018.217-.038.326-.058l.866,5.593a2.426,2.426,0,0,0,3.738,1.654L31.215,40.4a3.5,3.5,0,0,0,1.571-2.67l.513-6.639.13-.107a34.437,34.437,0,0,0,8.339-10.057A35,35,0,0,0,45.28,3.384Zm-15.53,34.8L23.2,42.517l-.844-5.451A29.753,29.753,0,0,0,30.472,33.2l-.334,4.325a.865.865,0,0,1-.388.659Zm-11.5-3.309-7.791-7.791a.861.861,0,0,1-.246-.747,22.848,22.848,0,0,1,1.037-3.946l11.69,11.69A22.945,22.945,0,0,1,19,35.121a.861.861,0,0,1-.747-.246ZM7.808,15.195l4.325-.334A29.75,29.75,0,0,0,8.267,22.98l-5.451-.844,4.333-6.553A.865.865,0,0,1,7.808,15.195Zm23.92,13.749a30.451,30.451,0,0,1-6.148,4.021L12.368,19.753a30.978,30.978,0,0,1,4.021-6.148,31.7,31.7,0,0,1,9.238-7.681A32.306,32.306,0,0,1,41.8,2.705a.871.871,0,0,1,.824.824,32.3,32.3,0,0,1-3.218,16.178,31.7,31.7,0,0,1-7.681,9.237Z"
                    transform="translate(0 0)"/>
              <path id="Path_55030" data-name="Path 55030"
                    d="M282.087,99.04a6.359,6.359,0,1,0-4.5-1.861A6.345,6.345,0,0,0,282.087,99.04Zm-2.7-9.061a3.818,3.818,0,1,1-1.118,2.7A3.806,3.806,0,0,1,279.387,89.979Z"
                    transform="translate(-250.889 -78.544)"/>
              <path id="Path_55031" data-name="Path 55031"
                    d="M1.574,349.666a1.268,1.268,0,0,0,.9-.373l4.155-4.155a1.273,1.273,0,1,0-1.8-1.8L.674,347.493a1.273,1.273,0,0,0,.9,2.173Z"
                    transform="translate(-0.276 -312.367)"/>
              <path id="Path_55032" data-name="Path 55032"
                    d="M10.162,388.218a1.273,1.273,0,0,0-1.8,0L.373,396.208a1.273,1.273,0,1,0,1.8,1.8l7.989-7.989A1.273,1.273,0,0,0,10.162,388.218Z"
                    transform="translate(-0.001 -353.047)"/>
              <path id="Path_55033" data-name="Path 55033"
                    d="M94.591,433.1l-4.155,4.155a1.273,1.273,0,1,0,1.8,1.8l4.155-4.155a1.273,1.273,0,0,0-1.8-1.8Z"
                    transform="translate(-82.028 -394.12)"/>
            </svg>
            <p>All Questions</p>
          </div>
        </div>
        <div class="col-6 col-md-6 col-lg-3 cat-item" v-for="item in categories" :key="item.id"
             @click="selectedCategory = item; selectedCat = item.id">
          <div class="faq-block" :class="{'active': selectedCat == item.id}">
            <img :src="item.logo" height="45">
            <p>{{ item.name }}</p>
          </div>
        </div>

      </div>

      <div class="faq-block-content-wrapper">
        <div class="faq-block-content">
          <h4>{{ selectedCategory.name }}</h4>
          <p>Starting In 2004, World Robot Olympiad Has Developed To A Truly Global Competition.
            WRO Tournaments Are Organized In More Than 60 Countries </p>
        </div>

      </div>

      <!-- questions -->
      <q-list>
        <div class="qu-item" v-for="item in categories_qu" :key="item.id" v-if="categories_qu">
          <q-expansion-item>
            <template v-slot:header>
              <q-item-section>
                {{ item.question }}
              </q-item-section>
            </template>

            <q-card>
              <q-card-section>
                {{ item.answer }}
              </q-card-section>
            </q-card>
          </q-expansion-item>
          <q-separator/>
        </div>
      </q-list>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading/loading";

export default {
  name: "FAQ",
  components: {Loading},
  data() {
    return {
      selectedCat: '0',
      categories: [],
      categories_id: '',
      categories_qu: [],
      loading: true,
      form: {
        question: null
      },
      selectedCategory: {
        name: 'All Questions'
      }
    }
  },
  mounted() {
    this.$API.web.FAQ.category_FAQ()
        .then(response => {
          this.loading = false;
          this.categories = response.data;
        })

    this.selectCat();
  },

  watch: {
    'selectedCategory'() {
      this.selectCat()
    }
  },
  methods: {
    selectCat() {
      this.$API.web.FAQ.show_FAQ({category_id: this.selectedCategory.id, question: this.form.question})
          .then(response => {
            this.categories_qu = response.data;
          })
    }
  }
}
</script>

<style scoped>
.cat-item {
  margin-bottom: 18px;
}
</style>